import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 16H14V15H4V16ZM14.069 8.17241C14.1343 8.11016 14.0903 8 14 8H11V3H7V8H4C3.90973 8 3.86567 8.11016 3.93103 8.17241L9 13L14.069 8.17241Z",
		fill: "black"
	})
});
export default SvgDownload;
